<template>
	<div class="header-page">
    <div class="flex flex-between">
      <div class="" @click="showMenu">
        <img src="../../static/images/menu.png" />
      </div>
      <a class="logo" href="#/"><img src="static/images/logo1.png" /></a>
    </div>
		<!-- <img :src="lang=='my'?'static/images/en.png':'static/images/en1.png'" @click="getLang(1,'')" class="en-my" />
		<div class="en-list" v-if="isEnShow">
			<span :class="{'active':lang=='my'}" @click="getLang(2,'my')">မြန်မာ</span>
			<span :class="{'active':lang=='en'}" @click="getLang(2,'en')">English</span>
		</div> -->
    <div class="menu-list" v-if="isShowMenu">
      <div class="modal-bg menu-bg" @click="showMenu"></div>
      <div class="menu-content">
        <div class="">
          <img @click="showMenu" class="close-img" src="static/images/close.png" />
        </div>
        <ul class="menu-li mt100">
          <router-link :to="{path:'/myAccount'}" v-if="isShowlogin" class="li">
            <span>{{$t('myAccount')}}</span>
            <img src="../../static/images/jiantou.png" />
          </router-link>
          <router-link :to="{path:'/faq'}" class="li">
            <span>{{$t('FAQs')}}</span>
            <img src="../../static/images/jiantou.png" />
          </router-link>
          <router-link :to="{path:'/termsAndCondition'}" class="li">
            <span>{{$t('T_C')}}</span>
            <img src="../../static/images/jiantou.png" />
          </router-link>
        </ul>
        <div class="unsubscribe" @click="unSubscribe" v-if="isShowlogin">
          <button class="button mt30 fs40">{{$t('Unsubscribe')}}</button>
        </div>
      </div>
    </div>
		<Dialog ref="saveDialog" :callback="saveModal" title="" :btnText="$t('Yes')" :cancelText="$t('No')">
      <div slot="mdBox" class="ac">
          <img class="tan" src="../../static/images/tan.png" />
          <div class="ac modal-ft-bg mt50 fs33">{{$t('des')}}</div>
      </div>
		</Dialog>
	</div>
</template>
<script>
	import Dialog from '../components/dialog'
    export default {
      name: 'app-header',
      components:{
        Dialog
      },
      data () {
          return {
            search:'',
            isShow:false,
            menus:[
              {url:'/',name:'home'},
              {url:'/GARDENING',name:'GARDENING'},
              {url:'/CIRCUITS',name:'CIRCUITS'},
              {url:'/',name:'COOKING'},
              {url:'/',name:'CRAFT'},
              {url:'/',name:'LIVING'},
              {url:'/',name:'OUTSIDE'},
              {url:'/ebooks',name:'ebooks'},
            ],
            isShowMenu:false,
            isShowlogin:false,
            isEnShow:false,
            lang:'en'
          }
      },
      created(){
        if(localStorage.getItem('token')){
          this.isShowlogin = true
        }else{
          this.isShowlogin = false
        }
        if(localStorage.getItem('lang')){
          this.lang = localStorage.getItem('lang')
        }else{
          this.lang = 'en'
        }
      },
      methods: {
        getLang(type,lang){
          if(type==1){
            this.isEnShow = !this.isEnShow
          }else{
            this.isEnShow = false
            localStorage.setItem('lang',lang)
            location.reload()
          }
        },
        showMenu(){
          let that =this;
          this.isShow = false;
          this.isShowMenu = !this.isShowMenu;
        },
        getAcount(){
          let that =this;
          this.isShowMenu = false;
          this.isShow = !this.isShow;
        },
        unSubscribe(){
          this.isShow = false;
          this.$refs.saveDialog.showMaskFun();
        },
        // 弹框保存
        saveModal (){
          let that = this
          that.$api.post('/api/user/unsubscribe',null,r =>{
            that.$parent.$parent.returnCode(r,function(){
              localStorage.removeItem('token')
              localStorage.removeItem('mobile')
              localStorage.removeItem('username')
              that.$parent.$utils.alertText(r.msg,80);
              that.$router.push('/subscribe');
            })
          })
          this.$refs.saveDialog.closeMask();
        },
      }
    }
</script>



// WEBPACK FOOTER //
// src/components/header.vue